import axios from 'axios'

export const api = axios.create({
  headers: {
    'X-Strategy': 'token',
    Authorization: `Bearer ${process.env.REACT_APP_CNPJ_TOKEN}`
  }
})

export interface CepData {
  cep: string
  logradouro?: string
  bairro?: string
  cidade: string
  ibgeCidade: string
  estado: string
  ibgeEstado: string
  siglaEstado: string
}

export interface State {
  ibge: string
  estado: string
  sigla: string
}

export async function getCep(cep: string): Promise<CepData> {
  const url = `/api/cep/${cep}`
  const response = await api.get(url)
  const data = response.status === 200 ? response.data : undefined

  // Normaliza a resposta para usar propriedades minúsculas
  return {
    cep: data.cep,
    logradouro: data.Logradouro || data.logradouro,
    bairro: data.bairro,
    cidade: data.cidade,
    ibgeCidade: data.ibgeCidade,
    estado: data.estado,
    ibgeEstado: data.ibgeEstado,
    siglaEstado: data.siglaEstado
  }
}

export async function getStates(): Promise<State[]> {
  const url = `${process.env.REACT_APP_ADDRESS_URL}/estado`
  const response = await api.get(url)
  const data = response.data

  return data
}
